import React, { useEffect, useState } from "react";
import { purchaseApi } from "./api";
import { errorMessage } from "./utils";
import "./purchase.css";

const empty = {
  vendorName: "",
  contactPerson: "",
  mobile: "",
  alternateMobile: "",
  email: "",
  gstNo: "",
  panNo: "",
  address: "",
  city: "",
  state: "",
  pincode: "",
  bankName: "",
  accountHolderName: "",
  accountNo: "",
  ifscCode: "",
  branchName: "",
  paymentTerms: "",
  remark: "",
  status: "Active",
};

export default function VendorMaster() {
  const [rows, setRows] = useState([]),
    [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null),
    [open, setOpen] = useState(false);
  const [search, setSearch] = useState(""),
    [error, setError] = useState("");

  const load = async () => {
    try {
      const { data } = await purchaseApi.vendors.list({ search });
      setRows(data.vendors || []);
    } catch (e) {
      setError(errorMessage(e));
    }
  };
  useEffect(() => {
    load();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setError("");
    try {
      if (editing) await purchaseApi.vendors.update(editing, form);
      else await purchaseApi.vendors.create(form);
      setOpen(false);
      setEditing(null);
      setForm(empty);
      await load();
    } catch (err) {
      setError(errorMessage(err));
    }
  };

  const edit = (v) => {
    setEditing(v._id);
    setForm({ ...empty, ...v });
    setOpen(true);
  };
  const deactivate = async (id) => {
    if (!window.confirm("Deactivate this vendor?")) return;
    await purchaseApi.vendors.remove(id);
    load();
  };

  return (
    <div className="purchase-page">
      <div className="purchase-head">
        <div>
          <h1>Vendor Master</h1>
          <p>Create and manage purchase vendors.</p>
        </div>
        <button
          className="p-btn primary"
          onClick={() => {
            setEditing(null);
            setForm(empty);
            setOpen(true);
          }}
        >
          + Add Vendor
        </button>
      </div>
      {error && <div className="p-error">{error}</div>}
      <div className="p-card p-toolbar">
        <div className="p-field">
          <label>Search</label>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Vendor / code / mobile / GST"
          />
        </div>
        <button className="p-btn" onClick={load}>
          Search
        </button>
      </div>
      <div className="p-card p-table-wrap">
        <table className="p-table">
          <thead>
            <tr>
              <th>CODE</th>
              <th>VENDOR</th>
              <th>CONTACT</th>
              <th>GST</th>
              <th>CITY</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((v) => (
              <tr key={v._id}>
                <td>{v.vendorCode}</td>
                <td>
                  <b>{v.vendorName}</b>
                  <br />
                  <span className="p-muted">{v.email}</span>
                </td>
                <td>
                  {v.contactPerson}
                  <br />
                  {v.mobile}
                </td>
                <td>{v.gstNo || "-"}</td>
                <td>{v.city || "-"}</td>
                <td>{v.status}</td>
                <td className="p-actions">
                  <button onClick={() => edit(v)}>Edit</button>
                  {v.status === "Active" && (
                    <button onClick={() => deactivate(v._id)}>
                      Deactivate
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="p-modal-bg">
          <form className="p-modal" onSubmit={save}>
            <div className="p-modal-head">
              <h2>{editing ? "Edit Vendor" : "Add Vendor"}</h2>
              <button
                type="button"
                className="p-btn"
                onClick={() => setOpen(false)}
              >
                Close
              </button>
            </div>
            <div className="p-grid">
              {[
                ["vendorName", "Vendor Name *"],
                ["contactPerson", "Contact Person"],
                ["mobile", "Mobile"],
                ["alternateMobile", "Alternate Mobile"],
                ["email", "Email"],
                ["gstNo", "GST No."],
                ["panNo", "PAN No."],
                ["city", "City"],
                ["state", "State"],
                ["pincode", "Pincode"],
                ["bankName", "Bank Name"],
                ["accountHolderName", "Account Holder"],
                ["accountNo", "Account No."],
                ["ifscCode", "IFSC"],
                ["branchName", "Branch"],
                ["paymentTerms", "Payment Terms"],
              ].map(([k, l]) => (
                <div className="p-field" key={k}>
                  <label>{l}</label>
                  <input
                    required={k === "vendorName"}
                    value={form[k] || ""}
                    onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                  />
                </div>
              ))}
              <div className="p-field span4">
                <label>Address</label>
                <textarea
                  value={form.address}
                  onChange={(e) =>
                    setForm({ ...form, address: e.target.value })
                  }
                />
              </div>
              <div className="p-field span4">
                <label>Remark</label>
                <textarea
                  value={form.remark}
                  onChange={(e) => setForm({ ...form, remark: e.target.value })}
                />
              </div>
            </div>
            <div style={{ marginTop: 15 }}>
              <button className="p-btn primary">
                {editing ? "Update Vendor" : "Save Vendor"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
